const { successRateLogger } = require('./logging');

function attachHubspotFormReadyListener(_$w, formsIds) {
  formsIds.forEach(formId => {
    successRateLogger(formId).requestStarted();
    _$w(`#${formId}`).on('hubspot-form-ready', event => {
      if (event.detail.isFormReady) {
        successRateLogger(formId).requestFinished();
      }
    });
  });
}

module.exports = {
  attachHubspotFormReadyListener,
};
